import React from 'react';
import { shape } from 'prop-types';

import QuoteImg from 'assets/images/quote.svg';
import styles from './Quote.module.scss';

const Quote = ({ content }) => (
  <div className={styles.wrapper}>
    <div className={styles.quoteImgContainer}>
      <QuoteImg />
    </div>
    <div className={styles.textContent}>
      <h2 className={styles.quoteText}>{content.text}</h2>
      <span className={styles.quoteSource}>/ {content.author}</span>
    </div>
  </div>
);

Quote.propTypes = {
  content: shape(),
};

Quote.defaultProps = {
  content: null,
};

export default Quote;
